import template from './breadcrumbs.html';
import controller from './BreadcrumbsController';

function directive() {
  return {
    scope: {
      searchType: '@',
      filterSet: '='
    },
    restrict: 'E',
    template,
    controller: 'TwpBreadcrumbsController'
  };
}

export default function (ngModule) {
  ngModule.directive('twpBreadcrumbs', directive);
  controller(ngModule);
}
